import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-afiliacion-banner',
  templateUrl: './afiliacion-banner.component.html',
  styleUrls: ['./afiliacion-banner.component.scss'],
})
export class AfiliacionBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
